var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 84,
    viewBox: "0 0 83 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_230_9678",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 8,
    width: 61,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2539 8.11151H82.8697V53.8238H22.2539V8.11151Z",
    className: "basecolor3Fill"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_230_9678)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0778 8.11151C78.0721 8.11151 77.1085 8.51381 76.3978 9.22883L41.1968 44.6222L28.7243 32.0811C27.7668 31.1188 26.371 30.7427 25.0631 31.095C23.7552 31.4476 22.7339 32.4746 22.3831 33.7896C22.0328 35.1046 22.4064 36.508 23.3639 37.4708L38.5168 52.7065C39.2275 53.4215 40.1915 53.8238 41.1972 53.8238C42.2025 53.8238 43.1665 53.4215 43.8768 52.7065L81.7586 14.6177C82.4697 13.9031 82.8698 12.9342 82.8698 11.9231C82.8698 10.9123 82.4697 9.94263 81.7586 9.22842C81.0475 8.51381 80.0835 8.11151 79.0778 8.11151Z",
    className: "color3Fill"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_230_9678",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 83,
    height: 84
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.134277H82.8663V83.5981H0V0.134277Z",
    className: "basecolor3Fill"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_230_9678)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.539 30.689C78.262 30.2594 76.855 30.5488 75.8475 31.4478C74.8399 32.3469 74.385 33.7191 74.6539 35.0466C76.2062 42.6801 75.1196 50.6183 71.5746 57.5437C68.0295 64.4691 62.2395 69.9649 55.1657 73.1187C48.0923 76.2725 40.1603 76.8947 32.6871 74.8819C25.2143 72.8691 18.6489 68.3427 14.0827 62.0536C9.51571 55.7644 7.22163 48.0915 7.58117 40.3088C7.9407 32.525 10.9331 25.1004 16.0603 19.267C21.188 13.4325 28.142 9.53952 35.768 8.23491C43.3945 6.9303 51.2348 8.29238 57.9877 12.0945C59.1653 12.7589 60.6046 12.7396 61.7646 12.0447C62.9246 11.3493 63.6281 10.0849 63.6106 8.72484C63.5926 7.36597 62.8568 6.11964 61.6788 5.45527C53.7427 0.978354 44.564 -0.743042 35.5593 0.555943C26.5554 1.85412 18.2247 6.10155 11.8549 12.6427C5.48542 19.183 1.42919 27.6534 0.313079 36.7467C-0.803031 45.8396 1.08322 55.0502 5.68015 62.9563C10.2771 70.8623 17.3297 77.0249 25.7494 80.4922C34.1691 83.9611 43.4866 84.5419 52.2671 82.1461C61.0475 79.7507 68.8008 74.5117 74.3307 67.2375C79.861 59.9628 82.8606 51.0576 82.8666 41.8952C82.8654 39.0862 82.5884 36.2837 82.0386 33.5302C81.7676 32.201 80.8147 31.1183 79.539 30.689Z",
    className: "color3Fill"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.fa72d7bdf74567acf89d2451637c2376.svg";
export { ForwardRef as ReactComponent };